import { Logger } from "@aws-amplify/core";

export const logger = new Logger("Frontend", "DEBUG");
